<script>
export default {
  name: "VToggleOnScroll",
  mounted() {
    if (this.enabled) {
      // Generate Classes
      this.$el.classList.add("js-toggleonscroll-item");

      if (this.anim !== "") {
        this.$el.classList.add(this.anim);
      }
      if (this.delay !== 0) {
        this.$el.classList.add(`delay-${this.delay}`);
      }

      // Initiate Observer
      this.observer = new IntersectionObserver(this.onElementObserved);
      this.observer.observe(this.$el);
    }
  },
  beforeDestroy() {
    // this.observer.disconnect();
  },
  props: {
    anim: {
      type: String,
      default: "fade-translate"
    },
    delay: {
      type: Number,
      default: 0
    },
    enabled: {
      type: Boolean,
      default: true
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  methods: {
    onElementObserved(entries) {
      const es = entries;

      es.forEach(item => {
        const i = item;
        const iT = i.target;
        const iTBounds = iT.getBoundingClientRect();
        const winW = window.innerWidth;
        const winH = window.innerHeight;

        if (
          i.isIntersecting ||
          (iTBounds.top <= winH && iTBounds.left <= winW)
        ) {
          iT.classList.add("visible");
        } else {
          iT.classList.remove("visible");
        }
      });
    }
  }
};
</script>

<template>
  <header v-if="tag === 'header'">
    <slot />
  </header>
  <footer v-else-if="tag === 'footer'">
    <slot />
  </footer>
  <section v-else-if="tag === 'section'">
    <slot />
  </section>
  <div v-else>
    <slot />
  </div>
</template>
